/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';
import { Form, Validator } from '@RockwellAutomation/rockwell-meteor';


const componentName = 'repair-request-form';
export class RepairRequestForm extends Component {
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        form: this.element.querySelector(`.${componentName}__form`),
        emailInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="email"]`),
        companyInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="company"]`),
        firstNameInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="firstName"]`),
        lastNameInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="lastName"]`),
        catalogNumberInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="catalogNumber"]`),
        catalogNumberContainer: this.element.querySelector(`.${componentName}__catalog-number-container`),
        catalogNumberAutosuggest: this.element.querySelector(`.${componentName}__catalog-number-autosuggest-container`),
        serialNumberInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="serialNumber"]`),
        termsCheckbox: this.element.querySelector(`.${componentName}__terms-checkbox-container input`),
        termsCheckboxLabel: this.element.querySelector(`.${componentName}__terms-checkbox-container label`),
        termsTextContainer: this.element.querySelector(`.${componentName}__terms-text`),
        fileInput: this.element.querySelector(`.${componentName}__insurance-upload-input`),
        fileNameTextTemplate: this.element.querySelector(`.${componentName}__insurance-upload-file-name-text-container-template`),
        fileNameList: this.element.querySelector(`.${componentName}__insurance-upload-file-name-list`),
        uploadFormField: this.element.querySelector(`.${componentName}__insurance-upload-container`),
        successCloseText: this.element.querySelector(`.${componentName}__success-message-close-text`),
        fileSizeExceededText: this.element.querySelector(`.${componentName}__insurance-upload-size-exceeded-text`),
        fileLimitExceededText: this.element.querySelector(`.${componentName}__insurance-upload-limit-exceeded-text`),
        textInputs: this.element.querySelectorAll(`.${componentName}__text-inputs .ra-input__input`),
        detailsTextarea: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="requestDetails"]`),
        detailsPlaceholder: this.element.querySelector(`.${componentName}__request-details-placeholder`),
        submitButton: this.element.querySelector(`.${componentName}__submit-button`),
        successMessageContainer: this.element.querySelector(`.${componentName}__success-message-container`),
        signedOutContainer: this.element.querySelector(`.${componentName}__signed-out-container`),
        signInLink: this.element.querySelector(`.${componentName}__signed-out-button`),
        invalidCatalogNumberMessage: this.element.querySelector(`.${componentName}__invalid-catalog-number-message`),
    };

    constants = {
        theme: this.elements.container.dataset.theme,
        catalogNumber: null,
        path: '/bin/right-to-repair',
        countryCode: document.documentElement.lang?.split('-')[1]?.toLowerCase() || 'us',
        autosuggestDebounceTime: 300,
    };

    state = {
        autosuggestDebounceTimer: null,
        catalogNumberValid: false,
        selectedFiles: [],
    };

    isFormValid = () => {
        if (!this.formEngine) return false;
        return this.formEngine.formFields.every(field => field.isValid());
    };



    isSameFile = (a, b) => a.name === b.name && a.size === b.size && a.lastModified === b.lastModified;

    /**
     * The input's FileList only ever holds the most recent selection, so the accumulated
     * list is kept in state and pushed back onto the input for form submission.
     */
    syncFileInput = () => {
        const dataTransfer = new DataTransfer();
        this.state.selectedFiles.forEach(file => dataTransfer.items.add(file));
        this.elements.fileInput.files = dataTransfer.files;
        if (this.state.selectedFiles.length === 0) {
            this.elements.fileInput.value = '';
        }
    };

    revalidateUpload = () => {
        this.elements.uploadFormField?.formField?.validate();
    };

    renderFileNameList = () => {
        this.elements.fileNameList.classList.toggle(`${componentName}__insurance-upload-file-name-list--has-files`, this.state.selectedFiles.length > 0);
        this.elements.fileNameList.querySelectorAll(`.${componentName}__insurance-upload-file-name-text-container`).forEach(item => {
            if (!item.classList.contains(`${componentName}__insurance-upload-file-name-text-container-template`)) {
                item.remove();
            }
        });
        this.state.selectedFiles.forEach(file => {
            const fileNameTextContainer = this.elements.fileNameTextTemplate.cloneNode(true);
            fileNameTextContainer.classList.remove('hidden');
            fileNameTextContainer.classList.remove(`${componentName}__insurance-upload-file-name-text-container-template`);
            fileNameTextContainer.querySelector(`.${componentName}__insurance-upload-file-name-text`).textContent = file.name;
            fileNameTextContainer.setAttribute('data-file-name', file.name);
            fileNameTextContainer.addEventListener('click', () => this.handleFileNameRemove(file));
            this.elements.fileNameList.appendChild(fileNameTextContainer);
        });
    };

    handleFileInputChange = (event) => {
        const newFiles = [...event.target.files];
        if (newFiles.length === 0) {
            this.syncFileInput();
            return;
        }

        // Files can be added one at a time, so merge each selection into what is already there.
        const mergedFiles = [...this.state.selectedFiles];
        newFiles.forEach(file => {
            if (!mergedFiles.some(existing => this.isSameFile(existing, file))) {
                mergedFiles.push(file);
            }
        });

        const limitExceeded = mergedFiles.length > 3;
        const sizeExceeded = mergedFiles.reduce((acc, file) => acc + file.size, 0) > 5 * 1024 * 1024;
        this.elements.fileLimitExceededText.classList.toggle('hidden', !limitExceeded);
        this.elements.fileSizeExceededText.classList.toggle('hidden', limitExceeded || !sizeExceeded);

        // Reject the whole selection on error and keep the previously accepted files.
        if (!limitExceeded && !sizeExceeded) {
            this.state.selectedFiles = mergedFiles;
        }
        this.syncFileInput();
        this.renderFileNameList();
        this.revalidateUpload();
    };

    handleFileNameRemove = (file) => {
        this.state.selectedFiles = this.state.selectedFiles.filter(existing => !this.isSameFile(existing, file));
        this.elements.fileLimitExceededText.classList.add('hidden');
        this.elements.fileSizeExceededText.classList.add('hidden');
        this.syncFileInput();
        this.renderFileNameList();
        this.revalidateUpload();
    };

    handleTermsCheckboxChange = () => {
        // Redundant change handlers nuked. Engine natively wipes validity status cleanly natively.
    };

    handleSubmit = async (event) => {
        if (event.defaultPrevented) return;
        event.preventDefault();

        if (this.isFormValid() && !this.state.catalogNumberValid) {
            this.elements.catalogNumberInput.focus();
            this.elements.catalogNumberContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        const formData = new FormData(this.elements.form);
        if (this.constants.catalogNumber) {
            formData.append('catalogNumber', this.constants.catalogNumber);
        }
        const response = await fetch(this.constants.path, {
            method: 'POST',
            body: formData,
        });

        const data = await response.text();

        this.elements.successMessageContainer.classList.remove('hidden');
        this.elements.form.classList.add('hidden');
    };

    handleTermsTextContainerScroll = () => {
        if (!this.elements.termsCheckbox || !this.elements.termsCheckbox.disabled) {
            this.elements.termsTextContainer.removeEventListener('scroll', this.handleTermsTextContainerScroll);
            return;
        }
        const scrollPosition = this.elements.termsTextContainer.scrollTop;
        const containerHeight = this.elements.termsTextContainer.clientHeight;
        const contentHeight = this.elements.termsTextContainer.scrollHeight;
        const isAtBottom = scrollPosition + containerHeight + 25 >= contentHeight;
        this.elements.termsCheckbox.disabled = !isAtBottom;
    };

    checkSignInStatus = () => {
        const queryParams = new URLSearchParams(window.location.search);
        let loggedInData;
        if (window['userData']) {
            loggedInData = window['userData'];
        } else if (localStorage.getItem('loggedInData')) {
            try {
                loggedInData = JSON.parse(localStorage.getItem('loggedInData'));
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData) {
            this.elements.emailInput.value = loggedInData?.email;
            this.elements.companyInput.value = loggedInData?.company;
            this.elements.firstNameInput.value = loggedInData?.firstName;
            this.elements.lastNameInput.value = loggedInData?.lastName;
            if (this.constants.catalogNumber) {
                this.elements.catalogNumberInput.value = this.constants.catalogNumber;
                this.elements.catalogNumberInput.disabled = true;
                this.elements.catalogNumberInput.classList.add(`${this.constants.theme}-input__input--disabled`);
                this.state.catalogNumberValid = true;
            } else if (queryParams.get('catalogNumber')) {
                this.elements.catalogNumberInput.value = queryParams.get('catalogNumber');
            }
            this.elements.form.classList.remove('hidden');
        } else {
            this.elements.signedOutContainer.classList.remove('hidden');
            this.elements.signInLink.addEventListener('click', () => {
                if (document.querySelector('.account-menu__sign-in')) {
                    document.querySelector('.account-menu__sign-in').click();
                } else {
                    if (localStorage.getItem('adfsLogin')) {
                        window.location.href = localStorage.getItem('adfsLogin');
                    }
                }
            });
        }
    };

    handleCatalogNumberInputChange = async () => {
        clearTimeout(this.state.autosuggestDebounceTimer);
        this.state.autosuggestDebounceTimer = setTimeout(() => {
            this.handleCatalogNumberInputChangeDebounced();
        }, this.constants.autosuggestDebounceTime);
    };

    handleCatalogNumberInputChangeDebounced = async () => {
        const catalogNumber = this.elements.catalogNumberInput.value;
        const autosuggestList = this.elements.catalogNumberAutosuggest.querySelector(`.${componentName}__catalog-number-autosuggest-list`);
        try {
            const response = await fetch(`${this.constants.path}?catalogNumber=${catalogNumber}&locale=${this.constants.countryCode}`);
            const data = await response.json();
            if (!data.success) {
                console.warn('Error fetching catalog numbers', data.error);
                this.elements.catalogNumberAutosuggest.classList.add('hidden');
                return;
            }
            const dataArray = data.catalogNumbers;
            if (dataArray.length === 0) {
                this.elements.catalogNumberAutosuggest.classList.add('hidden');
                this.state.catalogNumberValid = false;
                return;
            }
            autosuggestList.querySelectorAll(`.${componentName}__catalog-number-autosuggest-item`).forEach((item) => {
                if (!dataArray.includes(item.getAttribute('data-catalog-number'))) {
                    item.remove();
                }
            });

            dataArray.forEach((item) => {
                if (autosuggestList.querySelector(`[data-catalog-number="${item}"]`)) {
                    return;
                }
                const autosuggestItem = document.createElement('div');
                autosuggestItem.classList.add(`${componentName}__catalog-number-autosuggest-item`);
                autosuggestItem.setAttribute('tabindex', '0');
                autosuggestItem.setAttribute('data-catalog-number', item);
                autosuggestItem.textContent = item;
                autosuggestItem.addEventListener('mousedown', () => {
                    if (this.elements.catalogNumberInput.disabled) {
                        return;
                    }
                    this.elements.catalogNumberInput.value = item;
                    this.elements.catalogNumberAutosuggest.classList.add('hidden');
                    this.state.catalogNumberValid = true;
                    this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield--input-text`).classList.remove(`${this.constants.theme}-formfield--invalid-cn`);
                    this.elements.catalogNumberInput.classList.remove(`${this.constants.theme}-input__input--invalid-cn`);
                    this.elements.catalogNumberInput.dispatchEvent(new Event('change'));
                });
                autosuggestItem.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        if (this.elements.catalogNumberInput.disabled) {
                            return;
                        }
                        this.elements.catalogNumberInput.value = item;
                        this.elements.catalogNumberAutosuggest.classList.add('hidden');
                        this.state.catalogNumberValid = true;
                        this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield--input-text`).classList.remove(`${this.constants.theme}-formfield--invalid-cn`);
                        this.elements.catalogNumberInput.classList.remove(`${this.constants.theme}-input__input--invalid-cn`);
                        this.elements.catalogNumberInput.dispatchEvent(new Event('change'));
                    }
                });
                autosuggestItem.addEventListener('blur', async () => {
                    // If focus is no longer on the autosuggest list or input, hide the list
                    setTimeout(async () => {
                        if (!document.querySelector(`.${componentName}__catalog-number-autosuggest-item:focus`)
                            && !document.querySelector('input[name="catalogNumber"]:focus')) {
                            this.elements.catalogNumberAutosuggest.classList.add('hidden');

                            // If debounce timer is still running, wait for it to finish
                            if (this.state.autosuggestDebounceTimer) {
                                await new Promise(resolve => setTimeout(resolve, this.constants.autosuggestDebounceTime));
                            }
                            if (!this.state.catalogNumberValid && this.elements.catalogNumberInput.value !== '') {
                                if (this.elements.catalogNumberInput.disabled) {
                                    return;
                                }
                                this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).innerHTML = this.elements.invalidCatalogNumberMessage.innerHTML;
                                this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield--input-text`).classList.add(`${this.constants.theme}-formfield--invalid-cn`);
                                this.elements.catalogNumberInput.classList.add(`${this.constants.theme}-input__input--invalid-cn`);
                            } else if (this.elements.catalogNumberInput.value === '') {
                                this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).textContent = this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).dataset.originalErrorMessage;
                            }
                        }
                    }, 50);
                });
                autosuggestList.appendChild(autosuggestItem);
            });
            this.elements.catalogNumberAutosuggest.classList.remove('hidden');
            this.state.catalogNumberValid = dataArray.includes(catalogNumber);
            if (this.state.catalogNumberValid) {
                this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield--input-text`).classList.remove(`${this.constants.theme}-formfield--invalid-cn`);
                this.elements.catalogNumberInput.classList.remove(`${this.constants.theme}-input__input--invalid-cn`);
            }
        } catch (error) {
            console.warn('Error handling catalog number input change', error);
            autosuggestList.innerHTML = '';
            this.elements.catalogNumberAutosuggest.classList.add('hidden');
        }
    };

    handleCatalogNumberInputBlur = async () => {
        // If focus is not on the autosuggest list, hide
        setTimeout(async () => {
            if (!document.querySelector(`.${componentName}__catalog-number-autosuggest-item:focus`)) {
                this.elements.catalogNumberAutosuggest.classList.add('hidden');

                // If debounce timer is still running, wait for it to finish
                if (this.state.autosuggestDebounceTimer) {
                    await new Promise(resolve => setTimeout(resolve, this.constants.autosuggestDebounceTime));
                }
                if (!this.state.catalogNumberValid && this.elements.catalogNumberInput.value !== '') {
                    if (this.elements.catalogNumberInput.disabled) {
                        return;
                    }
                    this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).innerHTML = this.elements.invalidCatalogNumberMessage.innerHTML;
                    this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield--input-text`).classList.add(`${this.constants.theme}-formfield--invalid-cn`);
                    this.elements.catalogNumberInput.classList.add(`${this.constants.theme}-input__input--invalid-cn`);
                } else if (this.elements.catalogNumberInput.value === '') {
                    this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).textContent = this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).dataset.originalErrorMessage;
                }
            }
        }, 50);
    };

    addEventListeners = () => {
        this.elements.form.addEventListener('submit', async (event) => {
            this.elements.submitButton.disabled = true;
            window.dispatchEvent(new CustomEvent('show-loading'));
            await this.handleSubmit(event);
            window.dispatchEvent(new CustomEvent('hide-loading'));
            this.elements.submitButton.disabled = false;
        });
        this.elements.fileInput.addEventListener('change', this.handleFileInputChange);
        this.elements.termsCheckbox.addEventListener('change', this.handleTermsCheckboxChange);
        this.elements.catalogNumberInput.addEventListener('input', this.handleCatalogNumberInputChange);
        this.elements.catalogNumberInput.addEventListener('focus', this.handleCatalogNumberInputChange);
        this.elements.catalogNumberInput.addEventListener('blur', this.handleCatalogNumberInputBlur);
        document.addEventListener('click', async (event) => {
            if (!this.elements.catalogNumberInput.contains(event.target) && !this.elements.catalogNumberAutosuggest.contains(event.target)) {
                this.elements.catalogNumberAutosuggest.classList.add('hidden');

                // If debounce timer is still running, wait for it to finish
                if (this.state.autosuggestDebounceTimer) {
                    await new Promise(resolve => setTimeout(resolve, this.constants.autosuggestDebounceTime));
                }
                if (!this.state.catalogNumberValid && this.elements.catalogNumberInput.value !== '') {
                    if (this.elements.catalogNumberInput.disabled) {
                        return;
                    }
                    this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).innerHTML = this.elements.invalidCatalogNumberMessage.innerHTML;
                    this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield--input-text`).classList.add(`${this.constants.theme}-formfield--invalid-cn`);
                    this.elements.catalogNumberInput.classList.add(`${this.constants.theme}-input__input--invalid-cn`);
                }
            }
        });

        this.elements.termsTextContainer.addEventListener('scroll', this.handleTermsTextContainerScroll);
        const termsResizeObserver = new ResizeObserver(() => {
            if (this.elements.termsCheckbox.disabled) {
                this.elements.termsCheckbox.disabled = (this.elements.termsTextContainer.scrollHeight > (this.elements.termsTextContainer.offsetHeight + 5));
            }
        });
        termsResizeObserver.observe(this.elements.termsTextContainer);
    };

    initDom = () => {
        if (this.elements.container.dataset.catalogNumber) {
            this.constants.catalogNumber = this.elements.container.dataset.catalogNumber;
        } else if (window.location.pathname.includes('/products/details.')) {
            this.constants.catalogNumber = window.location.pathname.split('/products/details.')[1].split('.')[0];
        }
        if (this.elements.detailsTextarea && this.elements.detailsPlaceholder) {
            this.elements.detailsTextarea.setAttribute('placeholder', this.elements.detailsPlaceholder.textContent.trim());
        }
        if (this.elements.successCloseText && this.element.closest('.modal-container__dialog')) {
            this.elements.successCloseText.classList.remove('hidden');
        }
        this.checkSignInStatus();
        if (this.elements.termsCheckboxLabel.textContent.includes('*')) {
            this.elements.termsCheckboxLabel.textContent = this.elements.termsCheckboxLabel.textContent.replace('*', '.*');
        } else {
            this.elements.termsCheckboxLabel.textContent = this.elements.termsCheckboxLabel.textContent + '.';
        }
        this.elements.termsCheckbox.disabled = this.elements.termsTextContainer.scrollHeight > (this.elements.termsTextContainer.offsetHeight + 5);

        const customValidators = [
            new Validator((formField) => {
                if (formField.getInputElement()?.name !== 'insurance-document') return true;
                return this.state.selectedFiles.length > 0;
            })
        ];

        this.formEngine = new Form(this.elements.form, { customValidators });
        this.formEngine.init();

        let serialNumber = '';
        if (new URLSearchParams(window.location.search).get('SN')) {
            serialNumber = new URLSearchParams(window.location.search).get('SN');
        } else if (window.location.hash.startsWith('#SN=')) {
            serialNumber = window.location.hash.substring(4);
        }
        if (serialNumber) {
            this.elements.serialNumberInput.value = serialNumber;
        }

        this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).dataset.originalErrorMessage = this.elements.catalogNumberContainer.querySelector(`.${this.constants.theme}-formfield__caption-error`).textContent;
    };

    /**
     * Initialize Component
     */
    init = () => {
        if (typeof getPiraObj === 'function' || window.location.hostname.includes('localhost')) {
            this.initDom();
            this.addEventListeners();
        } else {
            document.addEventListener('piraLoadedSynced', () => {
                this.initDom();
                this.addEventListeners();
            });
        }
    };
}

registerComponent(`.${componentName}`, RepairRequestForm);
